import * as Actions from './actions';
import reducer from './reducer';

export { Actions };
export default reducer;
